export const APP_VERSION = "31dbdaa7ad27bc0a5403a2f2ae8322c3c7705c12";
